import React from 'react';
import { CheckCircle2, XCircle, Lightbulb } from 'lucide-react';

const DirectoryTestResult = ({ result }) => {
  if (!result) return null;
  const ok = !!result.ok;
  return (
    <div
      className={`rounded-lg border p-3 text-xs space-y-2 ${ok ? 'bg-emerald-50 border-emerald-200' : 'bg-rose-50 border-rose-200'}`}
      data-testid="dir-test-result"
    >
      <div className={`flex items-center gap-2 font-medium text-sm ${ok ? 'text-emerald-700' : 'text-rose-700'}`}>
        {ok ? <CheckCircle2 className="w-4 h-4" /> : <XCircle className="w-4 h-4" />}
        <span data-testid="dir-test-status">
          {ok
            ? `Connection OK — ${result.users_visible}${result.more_available ? '+' : ''} users visible`
            : 'Connection failed'}
        </span>
        {result.duration_ms != null && <span className="text-slate-500 font-normal">({result.duration_ms} ms)</span>}
      </div>
      {ok && result.sample_emails?.length > 0 && (
        <div className="text-slate-600" data-testid="dir-test-samples">
          Sample: {result.sample_emails.join(', ')}
        </div>
      )}
      {!ok && result.error && <div className="text-rose-700 break-all" data-testid="dir-test-error">{result.error}</div>}
      {!ok && result.hint && (
        <div className="flex gap-1.5 items-start text-amber-800" data-testid="dir-test-hint">
          <Lightbulb className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />{result.hint}
        </div>
      )}
      <div className="text-slate-500">Read-only check — no users were created or changed.</div>
    </div>
  );
};

export default DirectoryTestResult;
